// use client: handleOpenPdf runs on click (it opens the PDF in a new window), so
// these buttons need an event handler. Returns a fragment rather than its own
// wrapper so each host page keeps its existing row markup server-rendered.
'use client'

import { ClickableButton } from '@/components/buttons'
import { handleOpenPdf } from '@/utils'

interface PdfButtonsProps {
  items?: { label?: string; url?: string }[]
}

function PdfButtons({ items = [] }: PdfButtonsProps) {
  return (
    <>
      {items.map((item, index) => (
        <ClickableButton
          key={item.url ?? item.label ?? index}
          text={item.label}
          onClick={() => handleOpenPdf(item.url)}
        />
      ))}
    </>
  )
}

export default PdfButtons
